<script>
import {mapActions} from "vuex";

export default {
  name: "blogWidgetView",
  data() {
    return {
      blogList: [],
      curPage: 1
    };
  },
  methods:{
    ...mapActions("blog", ["getAllBlogPosts"]),
    callbackGetAllBlogPosts(res, type) {
      if (res.data.code === 0 ) {
        console.log(res.data.data.blogPojoList);
        this.blogList = res.data.data.blogPojoList.filter(blog => new Date(blog.publishedOn).getTime() <= Date.now());
      }
    },
    getPublishedBlogPosts() {
      this.getAllBlogPosts({ params: { page: this.curPage, pageSize: 8 }, callback: this.callbackGetAllBlogPosts });
    },
    truncateHtml(html) {
      // First, strip HTML tags
      const textContent = this.stripHtml(html);
      // Truncate the text if it is longer than 30 characters
      const truncatedText = textContent.length > 200 ? textContent.substring(0, 200) + '...' : textContent;
      return truncatedText;
    },
    stripHtml(html) {
      // Create a new div element and set its innerHTML to the provided HTML string
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      // Use the textContent property to extract plain text without HTML tags
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    redirectToBlog(id) {
      this.$router.push(`/blog/view/${id}`);
    },
    formatDate(dateString) {
      try {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
          return 'Invalid Date';
        }

        const year = date.toLocaleDateString('en-US', {
          timeZone: 'Australia/Adelaide',
          year: 'numeric'
        });

        const month = date.toLocaleDateString('en-US', {
          timeZone: 'Australia/Adelaide',
          month: 'long'
        });

        const day = date.toLocaleDateString('en-US', {
          timeZone: 'Australia/Adelaide',
          day: 'numeric'
        });

        return `${year} ${month} ${day}`;
      } catch (error) {
        console.error('Date formatting error:', error);
        return 'Invalid Date Format';
      }
    },
    viewAllPosts(){
      this.$router.push("/blog");
    }
  },
  created() {
    console.log("blog started");
    this.getPublishedBlogPosts();

  }
}
</script>

<template >
  <el-row v-if="blogList.length >3" >
    <el-col :span="24">
      <el-row>
        <el-col :span="24" class="blog-container">
          <div class="blog-header">
            <h2 class="blog-title-main">Latest Posts</h2>
            <el-button class="btn-primary view-all-btn" @click="viewAllPosts"
            >View All</el-button>
          </div>

          <div v-if="blogList.length > 0" class="blog-list">

            <div v-for="blog in blogList.slice(0, 8)">
              <!-- Card 1 -->
              <div class="blog-card" @click="redirectToBlog(blog.id)">
                <img :src="blog.imageUrl" alt="Blog post image" class="blog-image">
                <div class="blog-content">
                  <h1 class="blog-title">{{blog.title}}</h1>
                  <p class="blog-description"  v-html="truncateHtml(blog.content)"></p>
                </div>
                <div class="blog-date">
                  <time :datetime="blog.publishedOn">{{ formatDate(blog.publishedOn) }}</time>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="blog-list-empty">
            <span>No blogs found</span>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>

</template>

<style scoped lang="scss">
.blog-container {
  font-family: DINosaur-a, sans-serif;
  padding: 0 20px;
  background-color: #ffffff;
}

.blog-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.blog-title-main {
  background-color: #ffffff;
  color: #003333;
  font-size: 18px;
  margin: 0;
}

.view-all-btn {
  font-family: DINosaur-a, sans-serif;
  padding: 6px 12px;
  background-color: #003333;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.view-all-btn:hover {
  background-color: #003333;
}

.blog-list {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 16px; /* Space for scrollbar */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* Smooth scroll on iOS */
}

.blog-list-empty{
  min-height: 100px;
}

/* Hide scrollbar but keep functionality */
.blog-list {
  -ms-overflow-style: none;  /* IE 10+ */
  scrollbar-width: thin;  /* Firefox */
  scrollbar-color: #003333 #ffffff;
}

.blog-list::-webkit-scrollbar {
  display: none;  /* Chrome, Safari and Opera */
}

.blog-card {
  flex: 0 0 auto; /* Prevent card shrinking */
  width: 300px;
  height: 200px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.2s ease;
}

.blog-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.blog-image {
  width: 100%;
  height: 100px;
  object-fit: cover;
}

.blog-content {
  padding: 4px;
}

.blog-title {
  color: #003333;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 2px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.blog-description {
  font-size: 10px;
  margin: 0;
  color: #003333;
  background-color: #ffffff;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.blog-date {
  font-size: 10px;
  color: #003333;
  margin: auto 0 auto 12px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 10px;
  gap: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/blog/blogWidgetView/blogWidgetLayout.vue